import type { ComboboxProps } from '../Combobox';

export const assertMultiSelect = <TMultiselect extends boolean>({
  multiselect,
  value,
  maxSelectedOptions,
}: Pick<
  ComboboxProps<TMultiselect>,
  'multiselect' | 'value' | 'maxSelectedOptions'
>) => {
  if (!multiselect) {
    return;
  }
  if (!!value && !Array.isArray(value)) {
    throw new Error('value must be an array for multiselect combobox');
  }
  if (maxSelectedOptions && maxSelectedOptions < 1) {
    throw new Error('maxSelectedOptions must be greater than 0');
  }
};
